var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group',[_c('prd-numeric-input',{attrs:{"value":_vm.displayValue,"output-dec-seperator":","},on:{"input":_vm.onInput}}),_c('b-input-group-append',[_c('b-input-group-text',[_vm._v("ton")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }